export default __webpack_public_path__ + "static/media/compare.cc7498a2.webp";